import { Config } from 'config/envConfig';
export const validateUploadedFiles = async (newFiles, existingFiles = []) => {
    const MAX_TOTAL_ATTACHMENT_COUNT = Number(
        Config.MAX_TOTAL_ATTACHMENT_COUNT
    );
    const MAX_ATTACHMENT_PAGE_COUNT = Number(
        Config.MAX_ATTACHMENT_PAGE_COUNT
    );
    const TEXT_FILE_MAX_CHARS = Number(
        Config.TEXT_FILE_MAX_CHARS
    );

    const ALLOWED_EXTENSIONS = ['pdf', 'txt', 'png', 'jpg', 'jpeg', 'docx'];

    const errors = [];
    const validFiles = [];

    // Rule 1: total file count
    if (existingFiles.length + newFiles.length > MAX_TOTAL_ATTACHMENT_COUNT) {
        return {
            errors: [
                `A maximum of ${MAX_TOTAL_ATTACHMENT_COUNT} files is allowed.`,
            ],
            validFiles: [],
        };
    }

    // Duplicate detection
    const existingFileMap = new Set(
        existingFiles.map((f) => `${f.name}__${f.size}`)
    );

    for (const file of newFiles) {
        const ext = file.name.split('.').pop().toLowerCase();

        // Duplicate check
        if (existingFileMap.has(`${file.name}__${file.size}`)) {
            errors.push(`${file.name} was already uploaded.`);
            continue;
        }

        // Extension check
        if (!ALLOWED_EXTENSIONS.includes(ext)) {
            errors.push(`Unsupported file format: ${file.name}`);
            continue;
        }

        // TXT → character count check ONLY
        if (ext === 'txt') {
            try {
                const text = await file.text();
                if (text.length > TEXT_FILE_MAX_CHARS) {
                    errors.push(
                        `${file.name} exceeds ${TEXT_FILE_MAX_CHARS} characters.`
                    );
                    continue;
                }
            } catch {
                errors.push(`Unable to read text file ${file.name}.`);
                continue;
            }
        }

        // PDF → page count check
        if (ext === 'pdf') {
            try {
                const buffer = await file.arrayBuffer();
                const pdf = await window.pdfjsLib.getDocument({
                    data: buffer,
                }).promise;

                if (pdf.numPages >= MAX_ATTACHMENT_PAGE_COUNT) {
                    errors.push(
                        `${file.name} has ${pdf.numPages} pages (max ${
                            MAX_ATTACHMENT_PAGE_COUNT - 1
                        }).`
                    );
                    continue;
                }
            } catch {
                errors.push(`Unable to read PDF ${file.name}.`);
                continue;
            }
        }

        // DOCX → page count handled in backend

        validFiles.push(file);
    }

    return { errors, validFiles };
};
